// extracted by mini-css-extract-plugin
module.exports = {"editor":"views_editor__TChXE","aside":"views_aside__1wyqd","folder":"views_folder__eXerJ","textArea":"views_textArea__2apC3"};